/**
 * The public site this Control Center belongs with, for links an HR shares (a referral link).
 *
 * Derived from where the Control Center itself is running, because there is no site URL in its
 * build: the staging console links to the staging site, so a link tried out on staging does not
 * send a real candidate's sign-up to production.
 */
export function siteOrigin(hostname: string = typeof window === 'undefined' ? '' : window.location.hostname): string {
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:3000';
  if (hostname.startsWith('staging')) return 'https://staging.trymintly.com';
  return 'https://www.trymintly.com';
}

/** The job seeker sign-up page with a referral code on it. */
export const referralLink = (code: string, hostname?: string) =>
  `${siteOrigin(hostname)}/jobseeker/registration?ref=${encodeURIComponent(code)}`;
